import React, { useEffect, useState } from 'react';
import { FaSave, FaTimes, FaSearch } from 'react-icons/fa';
import { courseAPI, bookAPI } from '../../../../utils/api';
import Swal from 'sweetalert2';

function MultiSelect({ options, value, onChange, placeholder }) {
  const [search, setSearch] = useState('');
  const filtered = options.filter(o => o.label.toLowerCase().includes(search.toLowerCase()));
  const toggle = (id) => {
    if (value.includes(id)) onChange(value.filter(v => v !== id));
    else onChange([...value, id]);
  };
  return (
    <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 10, background: '#f8fafc', overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderBottom: '1px solid #e2e8f0' }}>
        <FaSearch style={{ color: '#94a3b8', fontSize: '0.75rem', flexShrink: 0 }} />
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={`Search ${placeholder}…`}
          style={{ border: 'none', background: 'transparent', outline: 'none', width: '100%', fontSize: '0.87rem', color: '#374151' }}
        />
      </div>
      <div style={{ maxHeight: 180, overflowY: 'auto', padding: '4px 0' }}>
        {filtered.map(o => (
          <label key={o.value} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 14px', cursor: 'pointer', fontSize: '0.88rem', color: '#374151', transition: 'background 0.12s' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
            onMouseLeave={e => e.currentTarget.style.background = ''}>
            <input type="checkbox" checked={value.includes(o.value)} onChange={() => toggle(o.value)}
              style={{ accentColor: 'var(--eduss-primary)', width: 15, height: 15, cursor: 'pointer' }} />
            {o.label}
          </label>
        ))}
        {filtered.length === 0 && (
          <div style={{ padding: '10px 14px', color: '#94a3b8', fontSize: '0.85rem' }}>No books found</div>
        )}
      </div>
      {value.length > 0 && (
        <div style={{ padding: '6px 14px', borderTop: '1px solid #e2e8f0', fontSize: '0.78rem', color: '#64748b', background: '#f0f4f8' }}>
          {value.length} book{value.length > 1 ? 's' : ''} selected
        </div>
      )}
    </div>
  );
}

export default function CourseCreate({ onClose, onSubmit, course = null }) {
  const [name, setName] = useState(course?.name || '');
  const [allBooks, setAllBooks] = useState([]);
  const [selectedBookIds, setSelectedBookIds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    bookAPI.getAll().then(res => {
      const books = Array.isArray(res.data) ? res.data : [];
      setAllBooks(books);
      if (course) {
        const associated = course.Books || course.books || [];
        setSelectedBookIds(associated.map(b => b.id));
      }
    }).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      Swal.fire({ icon: 'error', title: 'Validation', text: 'Course name is required' });
      return;
    }
    setLoading(true);
    try {
      const payload = { name, books: selectedBookIds.map(id => ({ id })) };
      if (course?.id) {
        await courseAPI.update(course.id, payload);
      } else {
        await courseAPI.create(payload);
      }
      onSubmit && onSubmit();
      Swal.fire({ icon: 'success', title: course?.id ? 'Course updated' : 'Course created', timer: 1800, showConfirmButton: false });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const bookOptions = allBooks.map(b => ({ value: b.id, label: b.name + (b.book_code ? ` (${b.book_code})` : '') }));

  return (
    <form onSubmit={submit}>
      <div className="eduss-global-modal-field-grid">
        <div className="eduss-global-modal-field" style={{ gridColumn: '1 / -1' }}>
          <label>Course Name *</label>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Enter course name" required />
        </div>
        <div className="eduss-global-modal-field" style={{ gridColumn: '1 / -1' }}>
          <label>Associated Books</label>
          <MultiSelect
            options={bookOptions}
            value={selectedBookIds}
            onChange={setSelectedBookIds}
            placeholder="books"
          />
        </div>
      </div>

      <div className="eduss-global-modal-actions">
        <button type="button" className="eduss-global-modal-btn cancel" onClick={onClose}>
          <FaTimes /> Cancel
        </button>
        <button type="submit" className="eduss-global-modal-btn save" disabled={loading}>
          <FaSave /> {loading ? 'Saving…' : course?.id ? 'Update Course' : 'Create Course'}
        </button>
      </div>
    </form>
  );
}
